import * as Yup from "yup";
import { BaseEShopSchema } from "./BaseEShopSchema";

export const CreateEShopSchema = BaseEShopSchema.shape({
    is_active: Yup.boolean(),
});
